var MessageCtrl = function($scope, $state, gettextCatalog, Message, Notification) {
  /**
   * @type {!angular.Scope}
   * @private
   */
  this.scope_ = $scope;

  /**
   * @type {angular.Service}
   * @private
   */
  this.$state_ = $state;

  /**
   * @type {Object}
   * @private
   */
  this.message_ = null;

  /**
   * @type {Object}
   * @private
   */
  this.Message_ = Message;

  /**
   * @type {Function}
   * @private
   */
  this.Notification_ = Notification;

  this.gettextCatalog = gettextCatalog;

  $scope.setMessage = this.setMessage.bind(this);
};
/**
 * go back to in-/outbox
 */
MessageCtrl.prototype.goBack = function() {
  this.$state_.go('private.main.messages', { box: this.message_.box });
};

/**
 * delete current message
 * @param {Object} message
 */
MessageCtrl.prototype.delete = function() {
  var self = this;

  this.Message_.delete(this.message_).then(
    function() {
      self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Message deleted'));
      self.goBack();

      if (self.message_.topic === 'booking') {
        self.scope_.$emit('Booking:delete');
      }
    },
    function() {
      self.Notification_.addErrorMessage(
        self.gettextCatalog.getString('Cant remove message'),
        true,
      );
    },
  );
};

/**
 * privileged setter for message
 * @param message
 */
MessageCtrl.prototype.setMessage = function(message) {
  this.message_ = message;
};

module.exports = MessageCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/message/types/MessageCtrl.js